import React from 'react';
import { CircleXIcon } from 'lucide-react';
import { painPoints } from '../data/planning';
import { stats } from '../data/kit';
export function ProblemSection() {
  return <>
      <section className="stats-section ink" aria-label="The kit at a glance" data-id="element-177" data-mp="30gxvo1selnov">
        <div className="wrap stats" data-id="element-178" data-mp="30j0w7fr6mz7u">
          {stats.map(stat => <div key={stat.label} className="stat" data-id="element-179" data-mp="2vp6daejeio9t">
              <strong data-id="element-180" data-mp="39hcrvw6won75">{stat.value}</strong>
              <span data-id="element-181" data-mp="39gb893btqsdt">{stat.label}</span>
            </div>)}
        </div>
      </section>
      <section className="section night" id="the-problem" data-id="element-182" data-mp="35fr7lps1l6mx">
        <div className="wrap" data-id="element-183" data-mp="3jglj4hadznpt">
          <div className="section-heading" data-id="element-184" data-mp="3jequoszwpdgz">
            <p className="eyebrow" data-id="element-185" data-mp="3egz5i6qnc5gh">The weekly planning problem</p>
            <h2 data-id="element-186" data-mp="3ehs42kfgbonj">
              The group leaves.
              <br data-id="element-187" data-mp="1p1iwqsgmwlr4" />
              And you still have <span className="accent" data-id="element-188" data-mp="1p2kl1ymnv4qs">next week to plan.</span>
            </h2>
          </div>
          <div className="pain-grid" data-id="element-189" data-mp="1k498vh8w8i5e">
            {painPoints.map(point => <div key={point} className="pain-card" data-id="element-190" data-mp="je6dotpfma6a">
                <CircleXIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-191" data-mp="jbahpax59vkh" />
                <p data-id="element-192" data-mp="oa3v73cflmkn">{point}</p>
              </div>)}
          </div>
          <p className="pain-close" data-id="element-193" data-mp="sc8m3ubhw53l">How many more weeks do you want to build from scratch?</p>
        </div>
      </section>
    </>;
}